class spineAge {

  constructor() {

    this.faqQuestion = document.querySelectorAll('.spine_age_faq-q');

    this.targetDiv = document.querySelector('.spine_age_nav');
    this.headerDiv = document.querySelector('.header');
    this.headerSticky = document.querySelector('.sticky_header');

    this.popup = document.getElementById('customPopup');
    this.openBtn = document.getElementById('openPopup');
    this.closeBtn = document.getElementById('closePopup');
    this.overlay = this.popup.querySelector('.custom-popup__overlay');

    this.questionContainer = document.querySelector('.question_answer');
    this.progress = document.querySelector('.progress');
    this.questionCount = document.getElementById('questionCount');

    this.selectedAnswers = {};

    this.currentQuestion = 0;
    this.spineScore = 0;

    this.questions = this.questionAnswer();

    this.bindEvent();

    this.renderQuestion();
  }

  isMobileDevice() {
    return window.innerWidth <= 768;
  }

  bindEvent() {

    const _this = this;

    _this.faqQuestion.forEach((element) => {

      element.addEventListener('click', function () {

        const parent = element.parentElement;
        const isOpen = parent.classList.contains('open');

        _this.faqQuestion.forEach((item) => {
          item.parentElement.classList.remove('open');
        });

        if (!isOpen) {
          parent.classList.add('open');
        }
      });
    });

    this.headerScrollDesktop = this.headerScrollDesktop.bind(this);

    window.addEventListener('scroll', this.headerScrollDesktop);
    window.addEventListener('resize', this.headerScrollDesktop);

    this.openBtn.addEventListener('click', () => {
      this.openPopup();
    });

    this.closeBtn.addEventListener('click', () => {
      this.closePopup();
    });

    this.overlay.addEventListener('click', () => {
      this.closePopup();
    });

    this.headerScrollDesktop();
  }

  headerScrollDesktop() {

    if (this.isMobileDevice()) {
      this.targetDiv.classList.remove('spine_age_nav_activated');
      return;
    }

    if (!this.targetDiv) return;

    const targetOffset = this.targetDiv.offsetTop;
    const scrollTop = window.scrollY;

    if (scrollTop >= targetOffset) {
      this.targetDiv.classList.add('spine_age_nav_activated');
    } else {
      this.targetDiv.classList.remove('spine_age_nav_activated');
    }
  }

  openPopup() {

    this.popup.classList.remove('closing');
    this.popup.classList.add('active');

    this.headerSticky.classList.add('sticky_header__fixed');

    document.body.style.overflow = 'hidden';

    this.resetQuiz();
  }

  closePopup() {

    this.popup.classList.add('closing');

    setTimeout(() => {

      this.popup.classList.remove('active');
      this.popup.classList.remove('closing');

      this.headerSticky.classList.remove('sticky_header__fixed');

      document.body.style.overflow = '';

    }, 400);
  }

  questionAnswer() {

    return [
      {
        id: 1,
        question: "How old are you?",
        name: "age",
        answer: [
          {
            label: "Under 25",
            score: 0
          },
          {
            label: "25-35",
            score: 1
          },
          {
            label: "36-50",
            score: 2
          },
          {
            label: "51-65",
            score: 3
          },
          {
            label: "65 +",
            score: 4
          }
        ]
      },

      {
        id: 2,
        question: "How many hours a day do you spend at a desk or on your phone?",
        name: "desk_time",
        answer: [
          {
            label: "Less than 2 hours",
            score: 0
          },
          {
            label: "2-4 hrs",
            score: 1
          },
          {
            label: "4-8 hrs",
            score: 2
          },
          {
            label: "More than 8 hrs",
            score: 3
          }
        ]
      },

      {
        id: 3,
        question: "Which symptom do you notice most?",
        name: "symptom",
        answer: [
          {
            label: "Morning Stiffness",
            score: 1
          },
          {
            label: "Back pain during the day",
            score: 2
          },
          {
            label: "Neck pain or headaches",
            score: 2
          },
          {
            label: "Limited bending / flexibility",
            score: 1
          },
          {
            label: "None Yet",
            score: 0
          }
        ]
      },

      {
        id: 4,
        question: "How old is your current mattress?",
        name: "mattress_age",
        answer: [
          {
            label: "Less than 2 years",
            score: 0
          },
          {
            label: "2-5 years",
            score: 0
          },
          {
            label: "5-10 years",
            score: 1
          },
          {
            label: "More than 10 years",
            score: 2
          },
          {
            label: "Not sure",
            score: 1
          }
        ]
      },

      {
        id: 5,
        question: "What type of mattress do you sleep on?",
        name: "mattress_type",
        answer: [
          {
            label: "Firm ortho / Spring",
            score: 0
          },
          {
            label: "Medium Foam",
            score: 1
          },
          {
            label: "Soft memory foam",
            score: 2
          },
          {
            label: "Roll-pack / bed-in-a-box",
            score: 3
          },
          {
            label: "Not sure",
            score: 1
          }
        ]
      }
    ];
  }

  calculateScore() {

    let totalScore = 0;

    Object.keys(this.selectedAnswers).forEach((key) => {

      totalScore += this.selectedAnswers[key].score;
    });

    let result = {};

    if (totalScore <= 3) {

      result = {
        score: totalScore,
        spineAge: "Aligned with your chronological age",
        description: "Your spine is currently in a healthy range. Your posture, sleep habits, and mattress support appear balanced.",
        recommendation: "Nilkamal Ortho Medium Mattress"
      };

    } else if (totalScore <= 6) {

      result = {
        score: totalScore,
        spineAge: "2–5 years older than your chronological age",
        description: "Early spine ageing has started. You may already notice stiffness, posture fatigue, or occasional neck/back pain.",
        recommendation: "Nilkamal Ortho Pro Mattress"
      };

    } else if (totalScore <= 9) {

      result = {
        score: totalScore,
        spineAge: "5–10 years older than your chronological age",
        description: "Your spine is under visible stress. Poor sitting posture, extended screen time, and mattress fatigue are likely accelerating degeneration.",
        recommendation: "Nilkamal Orthopedic Zoned Support Mattress"
      };

    } else {

      result = {
        score: totalScore,
        spineAge: "10+ years older than your chronological age",
        description: "Accelerated spine ageing detected. Immediate correction in posture, sleep surface, and daily movement is strongly advised.",
        recommendation: "Nilkamal Advanced Ortho+ Recovery Mattress"
      };
    }

    return result;
  }

  renderQuestion() {

    const currentData = this.questions[this.currentQuestion];

    const answeredQuestions =
      Object.keys(this.selectedAnswers).length;

    const progressWidth =
      (answeredQuestions / this.questions.length) * 100;

    this.progress.style.width = `${progressWidth}%`;

    this.questionCount.innerText = currentData.id;

    this.questionContainer.innerHTML = '';

    let html = `
      <h2>${currentData.question}</h2>
    `;

    currentData.answer.forEach((item, index) => {

      const checked =
        this.selectedAnswers[currentData.name]?.label === item.label;

      html += `
        <label class="radio-card ${checked ? 'active' : ''}">

          <input
            type="radio"
            name="${currentData.name}"
            value="${index}"
            data-score="${item.score}"
            ${checked ? 'checked' : ''}
          />

          <span>${item.label}</span>

        </label>
      `;
    });

    if (this.currentQuestion > 0) {

      html += `
        <button class="back_button">
          ← Back
        </button>
      `;
    }

    this.questionContainer.innerHTML = html;

    this.bindRadioEvents();

    this.bindBackButton();
  }

  bindRadioEvents() {

    const allRadio =
      this.questionContainer.querySelectorAll('input[type="radio"]');

    allRadio.forEach((radio) => {

      radio.addEventListener('change', (e) => {

        const currentData =
          this.questions[this.currentQuestion];

        const selectedIndex =
          Number(e.target.value);

        const selectedOption =
          currentData.answer[selectedIndex];

        this.selectedAnswers[currentData.name] =
          selectedOption;

        this.questionContainer
          .querySelectorAll('.radio-card')
          .forEach((card) => {
            card.classList.remove('active');
          });

        e.target
          .closest('.radio-card')
          .classList.add('active');

        setTimeout(() => {

          this.currentQuestion++;

          if (this.currentQuestion < this.questions.length) {

            this.renderQuestion();

          } else {

            this.renderForm();
          }

        }, 300);
      });
    });
  }

  bindBackButton() {

    const backBtn =
      this.questionContainer.querySelector('.back_button');

    if (!backBtn) return;

    backBtn.addEventListener('click', () => {

      this.currentQuestion--;

      this.renderQuestion();
    });
  }

  renderForm() {

    this.progress.style.width = `100%`;

    this.questionContainer.innerHTML = `
    
      <div class="contact_form">

        <h2>Contact Details</h2>

        <div class="form_group">
          <input type="text" id="fullName" placeholder="Full Name">
          <span class="error_message" id="nameError"></span>
        </div>

        <div class="form_group">
          <input type="text" id="phoneNumber" placeholder="Phone No.">
          <span class="error_message" id="phoneError"></span>
        </div>

        <div class="form_group">
          <input type="email" id="emailId" placeholder="Email ID">
          <span class="error_message" id="emailError"></span>
        </div>

        <p class="contact_note">
          Retest in 6 weeks after switching to see your Spine Score improve.
        </p>

        <button class="submit_spine_form">
          SEND AND GET YOUR SPINE SCORE
        </button>

      </div>
    `;

    document
      .querySelector('.submit_spine_form')
      .addEventListener('click', () => {

        const name =
          document.getElementById('fullName').value.trim();

        const phone =
          document.getElementById('phoneNumber').value.trim();

        const email =
          document.getElementById('emailId').value.trim();

        // Clear previous errors
        document.getElementById('nameError').innerText = '';
        document.getElementById('phoneError').innerText = '';
        document.getElementById('emailError').innerText = '';

        let isValid = true;

        // Validation
        if (!name) {
          document.getElementById('nameError').innerText = 'Please enter your name';
          isValid = false;
        }

        if (!phone) {
          document.getElementById('phoneError').innerText = 'Please enter phone number';
          isValid = false;
        } else if (!/^\d{10}$/.test(phone)) {
          document.getElementById('phoneError').innerText = 'Please enter valid 10-digit phone number';
          isValid = false;
        }

        if (!email) {
          document.getElementById('emailError').innerText = 'Please enter email address';
          isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          document.getElementById('emailError').innerText = 'Please enter valid email address';
          isValid = false;
        }

        if (!isValid) {
          return;
        }

        const finalData = {
          ...this.selectedAnswers,
          name,
          phone,
          email
        };

        console.log('Final Data:', finalData);

        this.getOtp(phone, finalData);

      });
  }

  renderOtpScreen(finalData) {

    this.questionContainer.innerHTML = `
    
      <div class="otp_verification">

        <h2>Verify OTP</h2>

        <p class="otp_description">
          We've sent a 6-digit code to ${finalData.phone}
        </p>

        <div class="otp_input_container">
          <input type="text" class="otp_input" maxlength="1" placeholder="0" data-index="0">
          <input type="text" class="otp_input" maxlength="1" placeholder="0" data-index="1">
          <input type="text" class="otp_input" maxlength="1" placeholder="0" data-index="2">
          <input type="text" class="otp_input" maxlength="1" placeholder="0" data-index="3">
          <input type="text" class="otp_input" maxlength="1" placeholder="0" data-index="4">
          <input type="text" class="otp_input" maxlength="1" placeholder="0" data-index="5">
        </div>

        <span class="error_message" id="otpError"></span>

        <button class="verify_otp_btn" disabled>
          VERIFY & GET SCORE
        </button>

        <p class="resend_note">
          Didn't receive? <button class="resend_otp_btn">Resend OTP</button>
        </p>

      </div>
    `;

    this.bindOtpInput(finalData);
  }

  bindOtpInput(finalData) {

    const _this = this;
    const otpInputs = this.questionContainer.querySelectorAll('.otp_input');
    const verifyBtn = this.questionContainer.querySelector('.verify_otp_btn');
    const resendBtn = this.questionContainer.querySelector('.resend_otp_btn');
    const otpError = this.questionContainer.querySelector('#otpError');

    otpInputs.forEach((input, index) => {

      input.addEventListener('keyup', (e) => {

        // Only allow numbers
        if (!/[0-9]/.test(e.key)) {
          input.value = '';
          return;
        }

        // Clear error when user starts typing
        otpError.innerText = '';

        // Move to next input on number entry
        if (input.value && index < otpInputs.length - 1) {
          otpInputs[index + 1].focus();
        }

        // Check if all inputs are filled
        const allFilled = Array.from(otpInputs).every(inp => inp.value !== '');
        verifyBtn.disabled = !allFilled;
      });

      // Handle backspace - move to previous input
      input.addEventListener('keydown', (e) => {

        if (e.key === 'Backspace' && !input.value && index > 0) {
          otpInputs[index - 1].focus();
        }
      });

      // Paste functionality
      input.addEventListener('paste', (e) => {

        e.preventDefault();
        const pastedData = (e.clipboardData || window.clipboardData).getData('text');
        const otpValues = pastedData.replace(/\D/g, '').split('');

        otpValues.forEach((value, i) => {
          if (i < otpInputs.length) {
            otpInputs[i].value = value;
          }
        });

        otpInputs[Math.min(otpValues.length, otpInputs.length - 1)].focus();

        const allFilled = Array.from(otpInputs).every(inp => inp.value !== '');
        verifyBtn.disabled = !allFilled;
      });
    });

    verifyBtn.addEventListener('click', () => {

      const otp = Array.from(otpInputs).map(input => input.value).join('');
      
      // Validate OTP
      if (otp.length !== 6) {
        otpError.innerText = 'Please enter a valid 6-digit OTP';
        return;
      }

      console.log('OTP Entered:', otp);

      _this.verifyOtp(otp, finalData);
    });

    resendBtn.addEventListener('click', () => {

      otpInputs.forEach(input => input.value = '');
      otpError.innerText = '';
      otpInputs[0].focus();
      _this.getOtp(finalData.phone, finalData);
    });

    // Focus on first input
    otpInputs[0].focus();
  }

  renderSuccess(result) {

    this.questionContainer.innerHTML = `

      <div class="success_screen">

        <h2>Spine Age</h2>

        <p class="success_subtitle">
          ${result.spineAge}
        </p>

        <p class="success_description">
          ${result.description}
        </p>

        <div class="recommend_box">
          <span>RECOMMENDED</span>
          <p>${result.recommendation}</p>
        </div>

        <span class="success__retest">Retest in 6 weeks after switching to see your Spine Score improve.</span>

        <div class="success_buttons">

          <a href="/collections/mattress" class="shop_btn">
            SHOP ORTHO MATTRESS
          </a>

          <button class="close_success">
            CLOSE
          </button>

        </div>

      </div>
    `;

    document
      .querySelector('.close_success')
      .addEventListener('click', () => {

        this.closePopup();
      });
  }

  resetQuiz() {

    this.currentQuestion = 0;

    this.selectedAnswers = {};

    this.renderQuestion();
  }

  getOtp(phoneNumber, finalData) {

    const formdata = new FormData();
    formdata.append("mobile_number", phoneNumber);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };

    fetch("https://middleware.doctordreams.com/api/send-otp", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        console.log('OTP Sent:', result);
        // Show OTP verification screen after OTP is sent
        this.renderOtpScreen(finalData);
      })
      .catch((error) => {
        console.error('Error sending OTP:', error);
        alert('Error sending OTP. Please try again.');
      });
  }

  verifyOtp(otp, finalData) {

    const _this = this;

    // Prepare FormData with all required fields
    const formdata = new FormData();
    formdata.append("mobile_number", finalData.phone);
    formdata.append("otp", otp);
    formdata.append("full_name", finalData.name);
    formdata.append("email", finalData.email);

    // Add all question answers
    formdata.append("question_1[]", finalData.age.label);
    formdata.append("question_2[]", finalData.desk_time.label);
    formdata.append("question_3[]", finalData.symptom.label);
    formdata.append("question_4[]", finalData.mattress_age.label);
    formdata.append("question_5[]", finalData.mattress_type.label);

    // Add web URL
    formdata.append("web_url", window.location.href);

    // Calculate and add spine score
    const result = this.calculateScore();
    formdata.append("your_spine_score", result.score);

    console.log('Verifying OTP with data:', {
      phone: finalData.phone,
      otp: otp,
      name: finalData.name,
      email: finalData.email,
      score: result.score
    });

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };

    // Show loading state
    const verifyBtn = this.questionContainer.querySelector('.verify_otp_btn');
    const otpError = this.questionContainer.querySelector('#otpError');
    
    if (verifyBtn) {
      verifyBtn.disabled = true;
      verifyBtn.innerText = 'VERIFYING...';
    }

    fetch("https://middleware.doctordreams.com/api/verify-otp-submit", requestOptions)
      .then((response) => response.json().catch(() => response.text()))
      .then((response) => {

        console.log('OTP Verification Response:', response);

        // Check if response is successful
        if (response && (response.success === true || response.status === 'success' || response.message)) {
          // Show success screen with calculated result
          _this.renderSuccess(result);

          // Reset selected answers
          _this.selectedAnswers = {};
        } else {
          // Show error
          const errorMsg = response?.message || response?.error || 'Invalid OTP. Please try again.';
          otpError.innerText = errorMsg;

          if (verifyBtn) {
            verifyBtn.disabled = false;
            verifyBtn.innerText = 'VERIFY & GET SCORE';
          }
        }
      })
      .catch((error) => {
        console.error('Error verifying OTP:', error);
        otpError.innerText = 'Error verifying OTP. Please try again.';

        if (verifyBtn) {
          verifyBtn.disabled = false;
          verifyBtn.innerText = 'VERIFY & GET SCORE';
        }
      });
  }
}

(function () {
  new spineAge();
})();